import 'animate.css'
import { createApp } from 'vue'
import i18n from '@/i18n/index'
import App from './App.vue'
import router from './router'
import store from './store'
import BaiduMap from 'vue-baidu-map-3x'
import 'dayjs/locale/zh-cn'
import './assets/iconfont/iconfont.css'
// import 'element-plus/theme-chalk/el-message.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './assets/scss/root.scss'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
const app = createApp(App)
app.use(VXETable)
app.use(ElementPlus)
app.config.warnHandler = () => null
app.config.errorHandler = () => null
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
import xss from 'xss'
app.config.globalProperties.$xss = xss

// import MapVue from "mapvue"
app.use(store).use(router).use(i18n).use(BaiduMap, {
  ak: 'SOU2Fqxqb6c1U4SMtcg7BeTQr86pxPk5',
  v: '3.0',
  type: 'WebGL'
})

router.isReady().then(() => {
  setTimeout(() => {
    app.mount('#app')
  }, 1500)
})
